import Plotly from 'plotly.js-dist-min';

// Для подгружаемого контента (demo_plotly.html и др.), где скрипты вызывают Plotly.newPlot — только локальная библиотека, без CDN
if (typeof window !== 'undefined') window.Plotly = Plotly;

function getPlotlyThemeLayout(baseLayout = {}) {
    const isDark = document.body.classList.contains('bg-dark');
    const dark = {
        paper_bgcolor: "#212529",
        plot_bgcolor: "#212529",
        font: { color: "#f8f9fa" }
    };
    const light = {
        paper_bgcolor: "#fff",
        plot_bgcolor: "#fff",
        font: { color: "#212529" }
    };
    return Object.assign({}, baseLayout, isDark ? dark : light);
}

export function renderRandomPlotlyChart(containerIdOrEl, options = {}) {
    let container = typeof containerIdOrEl === 'string'
        ? document.getElementById(containerIdOrEl)
        : containerIdOrEl;
    if (!container) return;

    const chartTypes = ['scatter', 'bar', 'pie', 'box', 'histogram'];
    const chartType = options.type || chartTypes[Math.floor(Math.random() * chartTypes.length)];
    const n = options.n || Math.floor(10 + Math.random() * 20);

    let data, layout;

    switch (chartType) {
        case 'scatter':
            data = [{
                x: Array.from({length: n}, (_, i) => i + 1),
                y: Array.from({length: n}, () => Math.random() * 100),
                type: 'scatter',
                mode: 'lines+markers',
                marker: {size: 8}
            }];
            layout = { title: 'Случайный Scatter', height: 300, margin: { t: 40 } };
            break;
        case 'bar':
            data = [{
                x: Array.from({length: n}, (_, i) => 'Категория ' + (i+1)),
                y: Array.from({length: n}, () => Math.random() * 100),
                type: 'bar'
            }];
            layout = { title: 'Случайная Гистограмма', height: 300, margin: { t: 40 } };
            break;
        case 'pie':
            data = [{
                labels: Array.from({length: Math.min(8, n)}, (_, i) => 'Сектор ' + (i+1)),
                values: Array.from({length: Math.min(8, n)}, () => Math.random() * 100 + 10),
                type: 'pie'
            }];
            layout = { title: 'Случайная Круговая диаграмма', height: 300, margin: { t: 40 } };
            break;
        case 'box':
            data = [{
                y: Array.from({length: n}, () => Math.random() * 100),
                type: 'box',
                boxpoints: 'all',
                jitter: 0.5
            }];
            layout = { title: 'Случайный Boxplot', height: 300, margin: { t: 40 } };
            break;
        case 'histogram':
            data = [{
                x: Array.from({length: n * 2}, () => Math.random() * 100),
                type: 'histogram'
            }];
            layout = { title: 'Случайный Histogram', height: 300, margin: { t: 40 } };
            break;
        default:
            data = [];
            layout = {};
    }

    Plotly.newPlot(container, data, getPlotlyThemeLayout(layout), {responsive: true});
}

window.getPlotlyThemeLayout = getPlotlyThemeLayout;


// draw plotly on pages from the backend
// Render each chart
window._plotly_data = {};

function renderAllCharts() {
    const figures = window.figures || {};
    for (const [id, fig] of Object.entries(figures)) {
        const el = document.getElementById(id);
        if (!el) continue;  // Просто пропусти, если такого div нет
        window._plotly_data[id] = {data: fig.data, layout: fig.layout};
        Plotly.newPlot(id, fig.data, getPlotlyThemeLayout(fig.layout), {responsive: true});
    }
}


// Запускать только после полной загрузки страницы!
if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', renderAllCharts);
} else {
    renderAllCharts();
}

// Theme changing
window.addEventListener('themechanged', function() {
    for (const [id, obj] of Object.entries(window._plotly_data)) {
        Plotly.react(id, obj.data, getPlotlyThemeLayout(obj.layout), {responsive: true});
    }
});
